export default function Location() {
  return (
    <section id="location" className="w-full bg-[#1e2708] py-16 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Title */}
        <h2 className="font-['Londrina_Solid'] text-[#c8e04a] text-5xl md:text-6xl tracking-widest uppercase text-center mb-4">
          Location
        </h2>

        {/* Divisore */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="h-px flex-1 bg-[#c8e04a]/30" />
          <div className="w-2 h-2 rounded-full bg-[#c8e04a]" />
          <div className="h-px flex-1 bg-[#c8e04a]/30" />
        </div>

        {/* Info evento */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-center gap-6 mb-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-map-pin-line text-[#c8e04a] text-2xl"></i>
            </div>
            <div>
              <p className="font-['Londrina_Solid'] text-white text-xl tracking-wider">
                Villa Comunale
              </p>
              <p className="font-['Londrina_Solid'] text-white/70 text-base tracking-wider">
                Piazza Caduti sul Lavoro, Parete (Ce)
              </p>
            </div>
          </div>
          <div className="hidden md:block h-10 w-px bg-[#c8e04a]/30" />
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-calendar-event-line text-[#c8e04a] text-2xl"></i>
            </div>
            <div>
              <p className="font-['Londrina_Solid'] text-white text-xl tracking-wider">
                24 &amp; 25 Aprile 2026
              </p>
              <p className="font-['Londrina_Solid'] text-white/70 text-base tracking-wider">
                Start ore 20.00
              </p>
            </div>
          </div>
        </div>

        {/* Mappa Google */}
        <div className="w-full rounded-lg overflow-hidden border-2 border-[#c8e04a]/30" style={{ height: "400px" }}>
          <iframe
            title="Villa Comunale Parete CE"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4261.192667789106!2d14.159956286510727!3d40.95698869937432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b0473d05cd6af%3A0xdb700222166285e1!2sPiazza%20Caduti%20Sul%20Lavoro!5e0!3m2!1sit!2sit!4v1774210231531!5m2!1sit!2sit"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* Link direzioni */}
        <div className="flex justify-center mt-6">
          <a
            href="https://maps.app.goo.gl/zCCWc9nwML2Z3VE76"
            target="_blank"
            rel="noopener noreferrer"
            className="font-['Londrina_Solid'] bg-[#475816] hover:bg-[#5a6e1a] text-[#c8e04a] border-2 border-[#c8e04a] text-lg tracking-widest uppercase px-8 py-3 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-navigation-line text-lg"></i>
            </div>
            Indicazioni Stradali
          </a>
        </div>
      </div>
    </section>
  );
}
